var $cafa55beb2fc5ef3$exports = {};
$cafa55beb2fc5ef3$exports = {
    "selectPlaceholder": `Select an item`,
    "tableResizer": `Resizer`,
    "dropzoneLabel": `DropZone`
};


export {$cafa55beb2fc5ef3$exports as default};
//# sourceMappingURL=en-US.module.js.map
